import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookie from 'vue-cookie';
import messages from './langs/index';

Vue.use(VueI18n);

const loc = Cookie.get('lang');

const i18n = new VueI18n({
  locale: loc || localStorage.lang || 'tw',
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js